import { Box, Stack, Text, useMantineTheme } from '@mantine/core'
import { ReactNode } from 'react'
import { SelectableCard } from '@/components/ui-shared/SelectableCard/SelectableCard'

type PreviewCardProps = {
  icon?: ReactNode
  title?: ReactNode
  content?: ReactNode
}

export const PreviewCard = ({ icon, title, content }: PreviewCardProps) => {
  const theme = useMantineTheme()

  return (
    <Box w={theme.other.deploymentCardHeight - 30}>
      <SelectableCard height={theme.other.deploymentCardHeight - 30}>
        <Stack h="100%" align="center" justify="center">
          {icon}

          {title && (
            <Text ta="center" size="sm" fw={600}>
              {title}
            </Text>
          )}

          {content}
        </Stack>
      </SelectableCard>
    </Box>
  )
}
